<template>
  <div class="down_wrap">
    <div class="container">
      <h2>下载央视体育VIP</h2>
      <div class="main">
        <div class="content">
          下载央视体育VIP App后，使用购买联合会员的手机号登录即可激活央视体育VIP会员
        </div>
        <div class="btn_wrap">
          <span @click="close">取消</span>
          <span @click="downCCTV">去下载</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    // 下载央视app
    downCCTV() {
      this.close()
      if (this.$COMMON.isIOS) {
        window.location.href = 'itms-apps://itunes.apple.com/app/id635830970'
      } else {
        // 安卓登录
        try {
          let query = JSON.stringify({"command": "launchApp", "params": { "package": "com.neulion.android.cntv", "marketPackage": ""}})
          window.LiveAppJS.nativeAction(query);
        } catch (e) {
          console.log('error')
        }
      }
    },
    // 关闭弹框按钮
    close() {
      this.$emit('close', false)
    }
  },
}
</script>
<style lang="less" scoped>
.down_wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background: rgba(0,0,0,0.5);
}
.container {
  width: 5.2rem;
  height: 4.32rem;
  background: #FFFFFF;
  border-radius: .2rem;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  h2 {
    font-size: .34rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222222;
    height: 1.2rem;
    text-align: center;
    width: 100%;
    line-height: 1.2rem;
    border-bottom: 1px solid #E5E5E5;
  }
  .main {
    padding: .27rem .3rem .3rem .3rem;
    box-sizing: border-box;
    .content {
      font-size: .28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: .4rem;
      text-align: center;
      padding: 0 .3rem;
      box-sizing: border-box;
    }
    .btn_wrap {
      display: flex;
      justify-content: space-between;
      margin-top: .48rem;
      span {
        width: 2.20rem;
        height: .8rem;
        background: #F4F5F7;
        border-radius: .45rem;
        font-size: .28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: .8rem;
        text-align: center;
        &:last-child {
          background: #FF4E38;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
